import React from 'react'
import useHeight from '../useHeight'
import TopBar from './TopBar'
import styles from './index.module.css'
import clsx from 'clsx'

interface AppLayoutProps {
    children?: React.ReactElement
    topBar?: React.ReactElement
    bottomBar?: React.ReactElement
    contentClassName?: string
}

export default function AppLayout(props: AppLayoutProps) {
    const [topRef, topHeight] = useHeight<HTMLDivElement>()
    const [btmRef, btmHeight] = useHeight<HTMLDivElement>()

    return (
        <>
            <div ref={topRef} className={styles.head}>
                <TopBar />
                { props.topBar &&
                    <div className={styles.topBar}>
                        {props.topBar}
                    </div>
                }
            </div>
            <div className={clsx(styles.content, props.contentClassName)} style={{
                paddingTop: topHeight,
                paddingBottom: btmHeight,
            }}>
                {props.children}
            </div>
            { props.bottomBar &&
                <div ref={btmRef} className={styles.foot}>
                    {props.bottomBar}
                </div>
            }
        </>
    )
}
